









import Vue from 'vue';
import Component from 'vue-class-component';
import autoBind from 'auto-bind';

import Dragdealer from 'dragdealer';
import 'dragdealer/src/dragdealer.css';

@Component
export default class SlideToUnlock extends Vue {

    public slideToUnlock: Dragdealer;

    private isUnlocked: boolean = false;

    public constructor() {
        super();
        autoBind(this);
    }

    public mounted() {
        this.slideToUnlock = new Dragdealer('unlock-slider', {
            steps: 100,
            speed: 0.15,
            animationCallback: this.onAnimate,
            callback: this.onSliderChanged
        });
    }

    public onAnimate(x: number) {
        if (!this.slideToUnlock) return;

        // Reenable after moving back to start
        if (x === 0) {
            this.slideToUnlock.enable();
        }
    }

    public onSliderChanged(x: number) {
        if (x > 0 && x < 0.80) {
            this.onSliderReset();
        } else if (x >= 0.80) {
            this.onSliderUnlocked();
        }
    }

    private onSliderReset() {
        // Move back to start
        this.slideToUnlock.disable();
        this.slideToUnlock.setValue(0, 0, false);
    }

    private onSliderUnlocked() {
        // Unlock position reached
        this.slideToUnlock.disable();
        this.isUnlocked = true;

        setTimeout(() => {
            this.$emit('unlocked');
        }, 500);
    }
}
